import type { PairwiseRates } from "@forgepoint/shared";

/**
 * Renders a pairwise exchange-rate table as a flat list of `from → to: rate` rows.
 * @param props.rates - the pairwise rate table to render
 * @returns the rate list element
 */
export function RatesList({ rates }: { rates: PairwiseRates }) {
  return (
    <div className="flex flex-col gap-1 text-sm text-muted-foreground">
      {Object.entries(rates).flatMap(([from, tos]) =>
        Object.entries(tos ?? {}).map(([to, rate]) => (
          <span key={`${from}:${to}`}>
            {from} → {to}: {rate}
          </span>
        )),
      )}
    </div>
  );
}
